import React from 'react';
import { useParallax } from '../hooks/useParallax';
import {
  HeroSection,
  ProposalSection,
  BenefitsSection,
  FAQSection,
  ContactSection,
} from './sections';
import WhatsappButton from '../components/WhatsAppButton';
import GoogleReviewsCarousel from '../components/GoogleReviewsCarousel';

function Home() {
  // Aplicar efecto parallax corregido - solo elementos decorativos
  useParallax();

  return (
    <div className="home-container">
      <WhatsappButton />
      <HeroSection />
      <ProposalSection />
      <BenefitsSection />
      <FAQSection />
  <GoogleReviewsCarousel />
      <ContactSection />
    </div>
  );
}

export default Home;
